import {Component, forwardRef, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-form-input-dropdown',
  templateUrl: './form-input-dropdown.component.html',
  styleUrls: ['./form-input-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputDropdownComponent),
      multi: true
    }
  ]
})
export class FormInputDropdownComponent implements OnInit, ControlValueAccessor {
  @Input() appendTo: string;
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() label: string;
  @Input() options: any;
  @Input() optionsField: string;
  @Input() filter: boolean = true;
  @Input() clearable: boolean = true;

  public id: string;

  public onChange = (_: any) => {
  }
  public onTouch = () => {
  }

  constructor() {
  }

  // function to catch input changes and update form in parent
  public onSelectChange($event: any): void {
    this.onTouch();
    this.onChange($event?.value);
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
  }

  // value accessor functions
  writeValue(value: any): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

}
